export default __webpack_public_path__ + "static/media/extension-shot.402a0a88.webp";